import moment from 'moment'
export default {
  data () {
    return {
      listOfUsers: []
    }
  },
  created () {
    this.getListOfUsers()
  },
  computed: {
    listOfPriority () {
      return [
        { text: this.$t('message.common.normal'), val: 'normal' },
        { text: this.$t('message.common.high'), val: 'high' },
        { text: this.$t('message.common.low'), val: 'low' }
      ]
    },
    listOfStatus () {
      return this.$_productionOrderStatus
    }
  },
  methods: {
    getListOfUsers () {
      this.$_getSingleRecordHandler('users')
        .then((response) => {
          if (response.data && response.data.length > 0) this.listOfUsers = response.data.filter(x => x.isactive)
        })
    },
    convertToNormalFormat (date) {
      if (!date) return ''
      if (moment(date, 'DD.MM.YYYY').isValid()) {
        return moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY')
      } else return ''
    },
    getUserDetails (userId) {
      if (!userId) return ''
      const user = this.listOfUsers.find(x => x.id === userId)
      if (user) return user.name
      else return ''
    }
  }
}
